import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'anyNull'
})
export class AnyNullPipe implements PipeTransform {

  transform(value: any): boolean {
    for (const key of Object.keys(value)) {
      if (value[key] === undefined || value[key] === null) {
        return true;
      }
    }
    return false;
  }

}
